// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"74dc8fb8","707":"b9febcf0"}[chunkId] + ".chunk.js";
};